<div class="invite-historic-dialog">
  <div class="invite-historic-dialog__year" *ngIf="year != null">
    Ano filtrado: {{ year }}
  </div>
  <div class="invite-historic-dialog__summary">
    <div class="invite-historic-dialog__card invite-historic-dialog__card--buy">
      <div class="invite-historic-dialog__label">{{ "add invite to buy" | translate }}</div>
      <div class="invite-historic-dialog__value">{{ addInviteToBuyCount }}</div>
    </div>
    <div class="invite-historic-dialog__card invite-historic-dialog__card--free">
      <div class="invite-historic-dialog__label">{{ "add free invite" | translate }}</div>
      <div class="invite-historic-dialog__value">{{ addFreeInviteCount }}</div>
    </div>
  </div>

  <p-table
    [value]="rows"
    styleClass="easy-table invite-historic-dialog__table"
    [scrollable]="true"
    scrollHeight="430px"
    [tableStyle]="{ 'min-width': '860px' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Ação</th>
        <th>Data início</th>
        <th>Nº adicional</th>
        <th>Liberado por:</th>
        <th>Status</th>
        <th>Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.action | translate }}</td>
        <td>{{ row.dateStart | date : "dd/MM/yyyy" }}</td>
        <td>{{ row.numberInviteToBuy ?? "—" }}</td>
        <td>{{ row.userNameStart || "—" }}</td>
        <td>
          <span *ngIf="row.block; else activeStatus">Cancelado</span>
          <ng-template #activeStatus>Ativo</ng-template>
        </td>
        <td>
          <button
            type="button"
            class="new-easymarine primary invite-historic-dialog__block-btn"
            [disabled]="!canBlock(row)"
            (click)="blockHistoric(row)"
          >
            Cancelar
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="invite-historic-dialog__empty">
          Nenhum registro de convite encontrado.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
